/**
 * Created by renjie.huang on 2017/10/11.
 */

import {
  Box,
  Button,
  Checkbox,
  Form,
  Icon,
  Input,
  Message,
  Modal,
} from "@ucloud-fe/react-components";
import { Typography } from "@ucloud/ui-components";
import { QRCodeSVG } from "qrcode.react";
import React from "react";
import { browserHistory } from "react-router";
import s from "underscore.string";
import validator from "validator";
import { default as action, default as actions } from "../../common/action.js";
import request from "../../common/request.js";
import serviceUrl from "../../common/serviceUrl.js";
import setTitle from "../../common/setTitle.js";
import { getGeetestLanguage } from "../../common/utils.js";
import uuid from "../../common/uuid.js";
import config from "../../config/config.js";
import { isMobile } from "../../service/deviceDetectService.js";
import localeService from "../../service/localeService.js";
import loginService from "../../service/loginService.js";
import registerService from "../../service/registerService.js";
import userInfoService from "../../service/userInfoService.js";
import userSerivce from "../../service/userService.js";
import localStorageService from "../../service/localStorageService.js";
import dasService from "../../service/dasService.js";
import Notice from "./Notice.jsx";
import Password from "./Password.js";
import NewPassword from "./NewPassword.js";
import PhoneInput from "./PhoneInput.jsx";
import SelectUser from "./SelectUser.jsx";
import TcCheckBox from "./TcCheckBox.jsx";
import OAuthBtn from "./ThirdPartyOAuth/OAuthBtn.jsx";
import OAuthGithub from "./ThirdPartyOAuth/OAuthGithub.jsx";
import { isChannelKeyEffect } from "../../common/channel.js"
import { SocialRegisterTitle } from "./style.jsx";
import cookie from '../../common/cookie'
const { Text } = Typography;
const QRImg =
  "https://www-s.ucloud.cn/2022/08/eb6bd6c89022223bfadb107ebf489eea_1661418866215.png";

const LOGIN_MODE = ["email", "phone"];
const ACTIVE_LOGIN_MODE = [
  // 邮箱登录
  "Email",
  // 手机号登录
  "Phone",
  //  扫码登录
  "ScanCode",
];
class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    var self = this;
    self.verifySid = uuid();
    self.query = self.props.location.query;
    self.service = serviceUrl(self.query["service"]);
    self.referrerUrl = cookie.getCookie('ytag') ? cookie.getCookie('ytag') : ''
    self.referrerCode = cookie.getCookie('bd_vid') ? cookie.getCookie('bd_vid') : ''
    self.referralCode = cookie.getCookie('referral_code') ? cookie.getCookie('referral_code') : ''
    if (self.query['ytag']) {
        self.referrerUrl = self.query['ytag']
    }
    if (self.query['bd_vid']) {
      self.referrerCode = self.query['bd_vid']
    }
    if (self.query['referral_code']) {
      self.referralCode = self.query['referral_code']
    }
    const hash = self.props.location.hash;
    const email = userInfoService.getUrlEmail(hash);

    //超级浏览器对接
    self.cid = self.query["cid"] ? decodeURIComponent(self.query["cid"]) : "";

    self.poll = null; // 扫码登录轮训
    self.loginType = ACTIVE_LOGIN_MODE[0]; // 当前激活登录方式

    this.state = {
      tcChecked: false,
      needWXAuth: false,
      wxModalOpen: false,
      isEmail: true,
      Email: "",
      Password: "",
      needSSID: false || APP_CONFIG.isAlwaysTriggerSecurityCode,
      errorMsg: "",
      isLoading: false,
      loginCopy: "",
      UserEmail: email || "",
      showLoginSuper: false,
      agreeSuperBrow: false,
      // 扫码登录
      QRErrorMsg: "",
      QRCodeUrl: "",
      QRUUID: "",
      scanLoginUserEmail: "",
      scannedWaitConfirm: false, // 是否为已扫码待确认状态
      loginMode: APP_CONFIG.preferredLoginMode || LOGIN_MODE[0], // 登录方式：邮箱登录/手机号登录
      phoneNumber: "",
      country: "86",
      PhoneCode: "",
      phoneUsers: [], // 手机号绑定的账号(账号已开通手机号登录功能)
      isShowSelectAccount: false, // 手机号登录，选择账号
      isLoginUseGtVerify: false, // 密码登录启用极验，不再使用图像验证码
    };
  }

  initVerify = () => {
    request(action.register.RegisterGeekVerification, {
      ClientType: "web",
      Applicant: "SendResetPasswordEmail",
      GeeTestVersion: "4.0",
    })
      .success((res) => {
        let succ = res && res.GeetestId;
        if (succ && res.Model == "geektest") {
          return window.initGeetest4(
            {
              captchaId: res.GeetestId,
              product: "bind",
              protocol: "https://",
              language: getGeetestLanguage(),
            },
            (captchaObj) => {
              captchaObj
                .onReady(() => {})
                .onSuccess(() => {
                  // 成功之后 跳转到邮箱发送结果页
                  const res = captchaObj.getValidate();
                  const result = {
                    GeeTestVersion: "4.0",
                    CaptchaId: res.captcha_id,
                    CaptchaOutput: res.captcha_output,
                    GenTime: res.gen_time,
                    LotNumber: res.lot_number,
                    PassToken: res.pass_token,
                  };
                  return this.sendEmailReset(result);
                })
                .onError((err) => {
                  this.setState({ isSending: false, errorMsg: err.msg });
                });
              // 按钮提交事件
              this.sendEmailVerify = (e) => {
                // 点击函数
                // 检测验证码是否ready, 验证码的onReady是否执行
                e && e.stopPropagation();
                return captchaObj.showCaptcha();
              };
            }
          );
        } else if (res && res.Model == "picture") {
          this.sendEmailVerify = () => {
            this.sendEmailReset(null);
          };
        }
      })
      .fail((err) => {
        this.setState({ errorMsg: localeService.getTranslate("LOGIN57") });
      });
  };

  sendEmailReset = (result) => {
    const { UserEmail, needSSID, scanLoginUserEmail, isLoginUseGtVerify } =
      this.state;
    let params = {
      UserEmail: this.loginType === "ScanCode" ? scanLoginUserEmail : UserEmail,
      CallbackUrl: registerService.getRetrieveUrl,
    };
    if (result) {
      params = { ...params, ...result };
    }
    if (needSSID && !isLoginUseGtVerify) {
      params["SID"] = this.verifySid;
      params["PictureCode"] = this.state.Code;
    }
    return loginService
      .sendRestPasswordEmailCode(params)
      .then((data) => {
        browserHistory.push(
          `/active?key=${data["Key"]}&validType=reset&mobile=none`
        );
      })
      .catch((err) => {
        this.setState({ errorMsg: err['I18N-Message'] || localeService.getTranslate(err["RetCode"]) });
      });
  };

  // 初始化登录极验
  initLoginVerify = () => {
    request(action.register.RegisterGeekVerification, {
      ClientType: "web",
      Applicant: "LoginByPassword",
      GeeTestVersion: "4.0",
    })
      .success((res) => {
        let succ = res && res.GeetestId;
        if (succ && res.Model == "geektest") {
          // Model='geektest' 表示 使用图形极验方式
          this.setState({ isLoginUseGtVerify: true });
          return window.initGeetest4(
            {
              captchaId: res.GeetestId,
              product: "bind",
              protocol: "https://",
              language: getGeetestLanguage(),
              hideSuccess: true,
            },
            (captchaObj) => {
              captchaObj
                .onReady(() => {})
                .onSuccess(() => {
                  // 成功之后 提交登录
                  const res = captchaObj.getValidate();
                  const result = {
                    GeeTestVersion: "4.0",
                    CaptchaId: res.captcha_id,
                    CaptchaOutput: res.captcha_output,
                    GenTime: res.gen_time,
                    LotNumber: res.lot_number,
                    PassToken: res.pass_token,
                    CaptchaType: "Behavior",
                  };
                  // 三方授权登录
                  if (this.LoginByOAuth) {
                    this.confirmOAuthBind(this.LoginByOAuth, result);
                  } else {
                    this.postLogin(result);
                  }
                  // hideSuccess:true时，需reset让验证回到初始状态，否则无感情况下onSuccess回调只会初始化走一次。
                  captchaObj.reset();
                })
                .onError((err) => {
                  this.setState({ isSending: false, errorMsg: err.msg });
                });
              this.loginPwGtVerify = (e) => {
                e && e.stopPropagation();
                return captchaObj.showCaptcha();
              };
            }
          );
        } else if (res && res.Model == "picture") {
          // Model='picture' 表示 使用验证码极验方式
          this.setState({ isLoginUseGtVerify: false });
          this.loginPwGtVerify = () => {
            this.postLogin(null);
          };
        }
      })
      .fail((err) => {
        this.setState({ errorMsg: localeService.getTranslate("LOGIN57") });
      });
  };

  // 生成扫码登录二维码
  getQRCodeUrl = () => {
    this.setState({ QRCodeUrl: "", QRErrorMsg: "", scannedWaitConfirm: false });
    request(actions.login.getQRCode, { QRCodeType: "Login" })
      .success((res) => {
        if (res.RetCode === 0) {
          const { Url, UUID } = res.Data;
          this.setState({ QRCodeUrl: Url, QRUUID: UUID }, () => {
            this.checkRealNameSession(UUID);
          });
        }
      })
      .fail((err) => {
        this.setState({ QRErrorMsg: err['I18N-Message'] || err.Message });
      });
  };

  /**
   * 扫码登录，轮训登录二维码状态
   * 1 未扫码
   * 2 已扫码，未确认
   * 3 已确认，登录成功
   */
  checkRealNameSession = (UUID) => {
    this.clearScanInterval();
    this.poll = setInterval(() => {
      request(actions.login.checkLoginQRCode, { UUID })
        .success((res) => {
          const { State } = res.Data;
          if (State === 2) {
            this.setState({ scannedWaitConfirm: true });
          }
          if (State === 3) {
            this.clearScanInterval();
            this.afterLoginSuccess();
          }
        })
        .fail((data) => {
          this.clearScanInterval();
          this.loginType = ACTIVE_LOGIN_MODE[2];
          var _RetCode = data["RetCode"];
          if (_RetCode == 11320) {
            // 二维码失效
            this.refreshQRCode();
          } else if (_RetCode === 11072) {
            // 账户未激活
            const userEmail = data["Data"]["UserEmail"] || "";
            this.reSendEmail(userEmail);
          } else if (_RetCode === 11945) {
            // 已开启TOTP验证，需要跳转TOTP验证页面
            userInfoService.getInstance().userInfo = { Ticket: data["Ticket"] };
            const service = encodeURIComponent(this.service);
            const url = `/OAuth/?service=${service}&loginType=${ACTIVE_LOGIN_MODE[2]}#google`;
            browserHistory.push(url);
          } else if (_RetCode === 11133) {
            // 主账号给子账号强制开启登录保护且子账号未绑定TOTP，需要跳转TOTP绑定和验证页面
            userInfoService.getInstance().userInfo = {
              Ticket: data["Ticket"],
              topInfo: data["TOTPInfo"],
            };
            const url = `/subaccountauth?loginType=${ACTIVE_LOGIN_MODE[2]}`;
            browserHistory.push(url);
          } else if (_RetCode === 11100 || _RetCode === 11361) {
            // 11100: 密码过期，需修改密码, 11361:安全风险或安全策略
            Message.error(
              { title: data['I18N-Message'] || localeService.getTranslate(_RetCode) },
              null
            );
            this.setState(
              { scanLoginUserEmail: data["Data"]["UserEmail"] },
              () => {
                this.sendEmailVerify && this.sendEmailVerify();
              }
            );
          } else if (_RetCode === 294) {
            // 访问IP被拒绝
            let text = data["Data"]["ClientIP"] || "";
            let texts = text ? (
              <span>
                {data['I18N-Message'] || localeService.getTranslate(_RetCode)}
                <br />
                {localeService.getTranslate("LOGIN61")}
                {text}
              </span>
            ) : (
              data['I18N-Message'] || localeService.getTranslate(_RetCode)
            );
            this.setState({ QRErrorMsg: texts });
          } else {
            this.setState({
              QRErrorMsg: data['I18N-Message'] || localeService.getTranslate(data.RetCode),
            });
          }
        });
    }, 2000);
  };

  clearScanInterval = () => {
    if (this.poll) {
      window.clearInterval(this.poll);
      this.poll = null;
    }
  };

  changeAgree(value) {
    this.setState({ agreeSuperBrow: value });
  }

  changeshowLoginSuper() {
    this.setState({
      showLoginSuper: false,
    });
  }

  afterLoginSuperBrow() {
    let messege = {
      action: "ucloudLogin",
      params: { login: true },
    };
    return chrome.runtime.sendMessage(this.cid, messege);
  }

  isLoginSuperBrow() {
    let {
      UserEmail,
      Password,
      needSSID,
      Code,
      loginMode,
      phoneNumber,
      PhoneCode,
      isLoginUseGtVerify,
    } = this.state;

    if (loginMode === LOGIN_MODE[0]) {
      // 邮箱登录
      if (!UserEmail) {
        this.setState({ errorMsg: localeService.getTranslate("LOGIN47") });
        return;
      }
      // else if (!validator.isEmail(UserEmail)) {
      //     this.setState({ errorMsg: localeService.getTranslate("LOGIN48") });
      //     return;
      // }
      if (!Password) {
        this.setState({ errorMsg: localeService.getTranslate("LOGIN49") });
        return;
      }
      if (needSSID && !Code && !isLoginUseGtVerify) {
        this.setState({ errorMsg: localeService.getTranslate("RETRIEVE18") });
        return;
      }
      if (this.cid) {
        return this.beforeLoginSuperBrow();
      }
      return this.login();
    } else {
      // 手机号登录
      if (!phoneNumber) {
        this.setState({ errorMsg: localeService.getTranslate("REGISTER01") });
        return;
      }
      if (!validator.isNumeric(phoneNumber)) {
        this.setState({
          errorMsg: localeService.getTranslate("INVALID_MOBILE"),
        });
        return;
      }
      if (!PhoneCode) {
        this.setState({ errorMsg: localeService.getTranslate("LOGIN8") });
        return;
      }
      this.loginByPhoneSms();
    }
  }

  beforeLoginSuperBrow() {
    const { UserEmail } = this.state;
    if (this.cid) {
      if (localStorage && localStorage.getItem(`${UserEmail}superbrow`)) {
        return this.login();
      }
      this.setState({
        showLoginSuper: true,
      });
    }
  }

  isAgreeSuperBrow() {
    const { agreeSuperBrow, UserEmail } = this.state;
    if (agreeSuperBrow) {
      this.setState({ showLoginSuper: false });
      localStorage && localStorage.setItem(`${UserEmail}superbrow`, true);
      return this.login();
    }
  }

  // 提交登录
  postLogin = (result) => {
    const self = this;
    const { UserEmail, Password, isLoginUseGtVerify } = self.state;

    let data = { LoginID: UserEmail, Password };

    if (result) {
      data = { ...data, ...result };
    }

    self.setState({
      errorMsg: "",
      loginCopy: localeService.getTranslate("LOGIN46"),
    });

    request(action.login.loginByPassword, data)
      .success(function (data) {
        if (self.cid) {
          return self.afterLoginSuperBrow();
        }
        self.afterLoginSuccess(data);
      })
      .fail(function (data) {
        if (!isLoginUseGtVerify) {
          self.verifySid = uuid();
          self.setState({ Code: "" });
        }

        self.loginType = ACTIVE_LOGIN_MODE[0];

        // 1. 账户未激活
        var _RetCode = data["RetCode"];
        if (_RetCode === 11072) {
          self.setState({ errorMsg: "" });
          self.reSendEmail();
          return;
        }
        // 2. 需要输入验证码错误
        if (_RetCode && (_RetCode == 220 || _RetCode == 13071)) {
          if (!isLoginUseGtVerify) {
            self.setState({ needSSID: true });
          } else {
            self.loginPwGtVerify && self.loginPwGtVerify();
          }
        } else if (_RetCode == 11945) {
          // 3. 已开启TOTP验证,需要跳转TOTP验证页面
          const service = encodeURIComponent(self.service);
          const url = `/OAuth/?service=${service}&loginType=${ACTIVE_LOGIN_MODE[0]}#google`;
          userInfoService.getInstance().userInfo = {
            userEmail: UserEmail,
            password: Password,
          };
          browserHistory.push(url);
        } else if (_RetCode == 11133) {
          // 4. 强制开启TOTP,需要跳转TOTP绑定和验证页面，主账号给子账号强制开启登录保护且子账号未绑定TOTP时
          const url = `/subaccountauth?loginType=${ACTIVE_LOGIN_MODE[0]}`;
          userInfoService.getInstance().userInfo = {
            userEmail: UserEmail,
            password: Password,
            topInfo: data.TOTPInfo,
          };
          browserHistory.push(url);
        } else if (_RetCode == 11100 || _RetCode === 11361) {
          // 5. 11100: 密码过期，需修改密码, 11361:安全风险或安全策略
          Message.error({ title: data['I18N-Message'] || localeService.getTranslate(_RetCode) }, null);
          self.sendEmailVerify && self.sendEmailVerify();
        } else if (_RetCode == 294) {
          // 6. 访问IP被拒绝
          let text = data["Data"]["ClientIP"] || "";
          let texts = text ? (
            <span>
              {data['I18N-Message'] || localeService.getTranslate(_RetCode)}
              <br />
              {localeService.getTranslate("LOGIN61")}
              {text}
            </span>
          ) : (
            data['I18N-Message'] || localeService.getTranslate(_RetCode)
          );
          self.setState({ errorMsg: texts });
        } else {
          self.setState({ errorMsg: data['I18N-Message'] ||  localeService.getTranslate(data.RetCode) });
        }
      })
      .always(function () {
        self.setState({ loginCopy: localeService.getTranslate("LOGIN2") });
      });
  };

  // 邮箱账号密码登录
  login() {
    var self = this;
    const { UserEmail, Password, isLoginUseGtVerify } = self.state;

    if (!UserEmail) {
      self.setState({ errorMsg: localeService.getTranslate("LOGIN47") });
      return;
    }
    // else if (!validator.isEmail(UserEmail)) {
    //     self.setState({ errorMsg: localeService.getTranslate("LOGIN48") });
    //     return;
    // }

    if (!Password) {
      self.setState({ errorMsg: localeService.getTranslate("LOGIN49") });
      return;
    }

    // 触发登录无感极验
    if (isLoginUseGtVerify) {
      self.loginPwGtVerify && self.loginPwGtVerify();
    } else {
      // 图形验证码校验
      if (self.state.needSSID && !self.state.Code) {
        self.setState({ errorMsg: localeService.getTranslate("RETRIEVE18") });
        return;
      }

      const res = {};
      if (self.state.needSSID) {
        res.SID = this.verifySid;
        res.Code = this.state.Code;
      }

      this.postLogin(res);
    }
  }

  submitDisabled() {
    var self = this;
    const { loginMode } = this.state;
    if (loginMode !== LOGIN_MODE[1]) {
      return false;
    }

    if (!self.state.tcChecked) {
      return true;
    }
    return false;
  }

  reSendEmail(userEmail = "") {
    var self = this;
    var data = {
      UserEmail: self.state.UserEmail,
      ActiveUrl: registerService.getActiveUrl(),
    };
    const email = userEmail || self.state.UserEmail;
    browserHistory.push(
      "/active?email=" + encodeURIComponent(email) + "&validType=resend"
    );
  }

  emailChange(e) {
    var value = e.target.value;
    value = s(value).trim().value();
    // var isEmail = validator.isEmail(value);
    this.setState({
      UserEmail: value,
      // isEmail: !!isEmail,
    });
  }

  pswordChange(val) {
    this.setState({
      Password: val,
    });
  }

  verifyChange(e) {
    this.setState({
      Code: e.target.value,
    });
  }

  onPasswordEnter(e) {
    var _value = e.target.value;
    if (e.keyCode == 13 && _value && this.state.isEmail) {
      this.login();
    }
  }

  onCodeSubmit(e) {
    var _value = e.target.value;
    if (e.keyCode == 13 && _value) {
      this.login();
    }
  }

  isEmailValid(event) {
    var _value = event.target.value;
    if (_value && !validator.isEmail(_value)) {
      this.setState({ errorMsg: localeService.getTranslate("LOGIN60") });
    } else {
      this.setState({ errorMsg: "" });
    }
  }

  afterLoginSuccess(data) {
    var self = this;
    userSerivce
      .getUserInfo()
      .then(function (data) {
        self.goToServiceUrl();
      })
      .catch(function (data) {
        self.goToServiceUrl();
      });
  }

  goToServiceUrl() {
    var _service = serviceUrl(this.props.location.query["service"]);
    window.open(_service, "_self");
  }

  changeVerifyCode() {
    this.verifySid = uuid();
    this.forceUpdate();
  }

  refreshQRCode = () => {
    this.clearScanInterval();
    this.getQRCodeUrl();
  };

  pageVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      this.clearScanInterval();
    }
    if (document.visibilityState === "visible") {
      this.checkRealNameSession(this.state.QRUUID);
    }
  };

  // 是否展示扫码登录（只ucloud渠道 && PC登录页展示）
  getIsShowQRLogin = () => {
    return APP_CONFIG.isShowQRLogin && !isMobile() && !isChannelKeyEffect();
  };

  componentDidMount() {
    this.initVerify();

    this.initLoginVerify();

    if (this.getIsShowQRLogin()) {
      this.getQRCodeUrl();
      // 监听页面可见性，页面不可见时停止对登录二维码状态的轮训。
      document.addEventListener("visibilitychange", this.pageVisibilityChange);
    }
  }

  componentWillUnmount() {
    if (this.getIsShowQRLogin()) {
      this.clearScanInterval();
      document.removeEventListener(
        "visibilitychange",
        this.pageVisibilityChange
      );
    }
  }

  handleChangeLoginMode = () => {
    const { loginMode } = this.state;
    this.setState({
      loginMode: loginMode === LOGIN_MODE[0] ? LOGIN_MODE[1] : LOGIN_MODE[0],
      errorMsg: "",
    });
  };

  updatePhoneState = (type, value) => {
    this.setState({ [type]: value });
  };

  // 手机短信验证码登录
  loginByPhoneSms = (userInfo) => {
    const { phoneNumber, country, PhoneCode } = this.state;
    const Code = PhoneCode || "";
    const UserPhone = `(${country})${phoneNumber}`;

    const UserID = (userInfo && userInfo["UserID"]) || "";
    const UserName = (userInfo && userInfo["UserName"]) || "";

    let params = { UserPhone, Code };
    if (this.referrerUrl) {
        params.ReferrerUrl = this.referrerUrl
    }
    if (this.referrerCode) {
      params.ReferrerCode = this.referrerCode
    }
    if (this.referralCode) {
      params.ReferralCode = this.referralCode
    }
    if (UserID) {
      params = { ...params, UserID };
    }

    request(actions.login.LoginBySms, params)
      .success(() => {
        this.afterLoginSuccess();
      })
      .fail((data) => {
        this.loginType = ACTIVE_LOGIN_MODE[1];
        const _RetCode = data["RetCode"];
        // 手机号绑定多个账号，选择账号登录
        if (_RetCode === 11331) {
          const Users = data["Data"]["Users"] || [];
          this.clearScanInterval();
          this.setState({
            isShowSelectAccount: true,
            phoneUsers: Users,
            errorMsg: "",
          });
        } else if (_RetCode === 11945) {
          // 已开启TOTP验证，需要跳转TOTP验证页面
          userInfoService.getInstance().userInfo = { UserPhone, Code, UserID };
          const service = encodeURIComponent(this.service);
          const url = `/OAuth/?service=${service}&loginType=${ACTIVE_LOGIN_MODE[1]}#google`;
          browserHistory.push(url);
        } else if (_RetCode === 11133) {
          // 主账号给子账号强制开启登录保护且子账号未绑定TOTP，需要跳转TOTP绑定和验证页面
          userInfoService.getInstance().userInfo = {
            UserPhone,
            Code,
            UserID,
            topInfo: data.TOTPInfo,
          };
          const url = `/subaccountauth?loginType=${ACTIVE_LOGIN_MODE[1]}`;
          browserHistory.push(url);
        } else if (_RetCode === 11072) {
          // 账户未激活，手机号选择账号登录时很低概率会出现账号未激活的情况
          if (UserName) {
            this.reSendEmail(UserName);
          } else {
            this.setState({
              errorMsg: data['I18N-Message'] || localeService.getTranslate(data.RetCode),
            });
          }
        } else if (_RetCode === 294) {
          // 访问IP被拒绝
          let text = data["Data"]["ClientIP"] || "";
          let texts = text ? (
            <span>
              {data['I18N-Message'] || localeService.getTranslate(_RetCode)}
              <br />
              {localeService.getTranslate("LOGIN61")}
              {text}
            </span>
          ) : (
            data['I18N-Message'] || localeService.getTranslate(_RetCode)
          );
          this.setState({ errorMsg: texts });
        } else {
          this.setState({ errorMsg: data['I18N-Message'] || localeService.getTranslate(data.RetCode) });
        }
      });
  };

  haneleKeyDown = (e) => {
    const value = e.target.value;

    if (e.keyCode == 13 && value) {
      this.isLoginSuperBrow();
    }
  };

  /**
   * 邮箱登录 && 手机号验证码登录
   */
  renderEmailAndPhoneLogin = () => {
    var self = this;
    const {
      loginMode,
      phoneNumber,
      country,
      PhoneCode,
      errorMsg,
      isLoginUseGtVerify,
    } = this.state;
    const isEmailLoginMode = loginMode === LOGIN_MODE[0]; // 邮箱登录
    const isScanLoginVisible = this.getIsShowQRLogin();
    const _verifyUrl = `${config.dws}/captcha?SID=${this.verifySid}`;
    const isShowPhoneLogin = APP_CONFIG.isShowPhoneLogin;
    const commitDisabled = this.submitDisabled();

    let isShowRegisterBtn = !APP_CONFIG.isHideRegister && !APP_CONFIG.isHideRegisterBtn;
    // 和 UCloud 或 UCloud Global 域名相同的渠道入口不直接显示注册按钮
    if(isChannelKeyEffect()){
      isShowRegisterBtn = false;
    }

    return (
      <div
        className={`account-login-box ${
          (isScanLoginVisible || (APP_CONFIG.loginAdBannerPic && !isMobile())) ? "account-rgap" : ""
        }`}
      >
        <SocialRegisterTitle>
          <div className="social-title-left">
            {localeService.getTranslate(
              isEmailLoginMode ? "LOGINACCOUNTPWD" : "LOGINPNONE"
            )}
          </div>

          {isShowPhoneLogin && (
            <div
              className="social-title-right"
              onClick={this.handleChangeLoginMode}
            >
              {isEmailLoginMode ? (
                <Icon className="primary-color u-mr6" type="mobile"></Icon>
              ) : (
                <Icon className="primary-color u-mr6" type="mail"></Icon>
              )}
              {localeService.getTranslate(
                isEmailLoginMode ? "LOGINPNONE" : "LOGINACCOUNTPWD"
              )}
            </div>
          )}
        </SocialRegisterTitle>

        {errorMsg ? (
          <Notice
            className="u-mt20 font-12"
            icon="circle-cross"
            message={errorMsg}
            styleType="error"
          />
        ) : null}
        <Form>
          {/* 邮箱登录 */}
          {isEmailLoginMode ? (
            <React.Fragment>
              <div
                className={!errorMsg ? "app-form-item fmt-36" : "app-form-item"}
                style={{ marginBottom: 24 }}
              >
                {/* <input type="password" style={{display:'none'}}></input> */}
                <Input
                  ref={(ref) => (self.userInput = ref)}
                  value={self.state.UserEmail}
                  name="username"
                  id="username"
                  autoComplete="on"
                  // onBlur={(event) => this.isEmailValid(event)}
                  onChange={this.emailChange.bind(this)}
                  onKeyDown={this.haneleKeyDown.bind(this)}
                  placeholder={localeService.getTranslate(
                    "LOGIN_ACCOUNT_PLACEHOLDER"
                  )}
                  size="lg"
                />
              </div>
              <NewPassword
                needTip={false}
                needStrength={false}
                passwardPolicy={ 
                  {
                    RequireUppercaseCharacters: true,
                    RequireLowercaseCharacters:true,
                    RequireNumbers:false,
                    RequireSymbols:true,
                    MinimumPasswordLength: 6,
                  }}
                onChange={this.pswordChange.bind(this)}
                onKeyDown={this.haneleKeyDown.bind(this)}
                placeholder={localeService.getTranslate("LOGIN1")}
              />
            </React.Fragment>
          ) : (
            // 手机号登录
            <React.Fragment>
              <div
                className={!errorMsg ? "app-form-item fmt-16" : "app-form-item"}
              >
                <div className="remark-text-color font-14 lh-14">
                  {localeService.getTranslate("DIRECT_REGISTR")}
                </div>
                <PhoneInput
                  phoneNumber={phoneNumber}
                  country={country}
                  PhoneCode={PhoneCode}
                  updatePhoneState={this.updatePhoneState}
                />
              </div>
            </React.Fragment>
          )}
        </Form>
        {this.state.needSSID && !isLoginUseGtVerify ? (
          <div>
            <div
              className="u-dib app-form-item"
              style={isMobile() ? {} : { width: "238px" }}
            >
              <Input
                onKeyDown={(event) => this.onCodeSubmit(event)}
                value={this.state.Code}
                onChange={this.verifyChange.bind(this)}
                style={isMobile() ? {} : { width: "238px" }}
              />
            </div>
            <div
              onClick={this.changeVerifyCode.bind(this)}
              className="verify-img-wrapper app-form-item u-dib u-vt"
              style={isMobile() ? {} : { marginTop: 24 }}
            >
              <img className="u-verify-code" src={_verifyUrl} />
            </div>
          </div>
        ) : null}
        <div className="u-clearfix">
          {/* 勾选协议 */}
          {loginMode === LOGIN_MODE[1] && (
            <TcCheckBox
              style={{}}
              checked={this.state.tcChecked}
              location={this.props.location}
              onChange={(val) => this.setState({ tcChecked: val })}
            />
          )}
          <Button
            styleType="primary"
            onClick={this.isLoginSuperBrow.bind(this)}
            size="lg"
            style={
              commitDisabled ? { pointerEvents: "none", opacity: 0.3 } : {}
            }
            className={`${isMobile() ? "" : "u-mt24"} login-btn`}
            id="login"
          >
            {self.state.loginCopy || localeService.getTranslate(loginMode === LOGIN_MODE[1] ? "LOGIN_REGISTER" : "LOGIN2")}
          </Button>
        </div>
        <Box
          container
          justifyContent="space-between"
          className={`font-14 ${
            !this.getIsShowQRLogin()
              ? "u-mt48"
              : isEmailLoginMode
              ? "e-lb-wrapper"
              : "p-lb-wrapper"
          }`}
        >
          {isShowRegisterBtn ? (
            <span
              className="register-link primary-color"
              onClick={() => {
                this.props.changeActiveState("registerTab");
              }}
            >
              {localeService.getTranslate("REGISTERNOW")}
            </span>
          ) : null}
          <a href="/retrieveByMobile" target="_blank" className="primary-color">
            {localeService.getTranslate("LOGIN3")}
          </a>
        </Box>
      </div>
    );
  };

  /**
   * 手机号登录，选择账号
   */
  renderSelectPhoneUserLogin = () => {
    return (
      <SelectUser
        phoneUsers={this.state.phoneUsers}
        errorMsg={this.state.errorMsg}
        userLoginChange={(userInfo) => {
          this.loginByPhoneSms(userInfo);
        }}
        cancelLoginChange={() => {
          this.getQRCodeUrl();
          this.setState({
            errorMsg: "",
            phoneUsers: [],
            isShowSelectAccount: false,
          });
        }}
      />
    );
  };

  /**
   * 扫码登录
   */
  renderScanCodeLogin = () => {
    const { scannedWaitConfirm, QRErrorMsg } = this.state;
    const isShowMask = scannedWaitConfirm || QRErrorMsg;
    return (
      <React.Fragment>
        {this.getIsShowQRLogin() ? (
          <div className="QR-login-wrapper">
            <div className="QR-title-box">
              <Typography.H3 size="t6" className="QR-title-text">
                {localeService.getTranslate("SCANCODELOGIN")}
              </Typography.H3>
            </div>
            <div className="QR-note-box normal-text">
              <span className="mr-4">{localeService.getTranslate("USE")}</span>
              <Text
                isLink
                component="a"
                color="dark"
                className="weight"
                href="https://www.ucloud.cn/site/ucloud_app.html"
                target="_blank"
              >
                UCloud App
              </Text>
              <span className="ml-4">
                {localeService.getTranslate("SCANLOGINNOTE")}
              </span>
            </div>
            <div
              className={isShowMask ? "QR-img-box" : "QR-img-box QR-img-border"}
            >
              {this.state.QRCodeUrl && (
                <QRCodeSVG
                  size={160}
                  value={this.state.QRCodeUrl}
                  imageSettings={{
                    width: 28,
                    height: 28,
                    src: QRImg,
                    excavate: true,
                  }}
                />
              )}
              {/* 已扫码待确认 */}
              {this.state.scannedWaitConfirm ? (
                <div className="QR-mask-box">
                  <Icon
                    className="mask-icon success-color"
                    style={{ display: "block" }}
                    type="circle-check_hover"
                  />
                  <div className="dark-text mask-text">
                    {" "}
                    {localeService.getTranslate("SCANNED")}
                  </div>
                  <div className="dark-text mask-text">
                    {localeService.getTranslate("CONFIRMCODELOGIN")}
                  </div>
                </div>
              ) : null}
              {/* 扫码登录失败，错误提示 */}
              {this.state.QRErrorMsg ? (
                <div className="QR-mask-box">
                  <Icon
                    type="circle-cross2"
                    style={{ display: "block" }}
                    className="mask-icon error-color"
                  />
                  <div className="dark-text mask-text">
                    {this.state.QRErrorMsg}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="QR-operate-box">
              <div className="operate-item">
                <Icon
                  className="operate-icon primary-color"
                  type="cloudshell-newtab"
                />
                <Text
                  isLink
                  size="t2"
                  component="a"
                  color="light"
                  href="https://www.ucloud.cn/site/ucloud_app.html"
                  target="_blank"
                >
                  {localeService.getTranslate("DOWNLOADAPP")}
                </Text>
              </div>
              <div className="operate-line"></div>
              <div
                className="operate-item"
                onClick={() => this.refreshQRCode()}
              >
                <Icon className="operate-icon primary-color" type="repeat" />
                <Text color="light" size="t2" isLink>
                  {localeService.getTranslate("CAMPUS15")}
                </Text>
              </div>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  };

  /**
   * Banner广告位
   */
  renderAdBanner = () => {
    if (!APP_CONFIG.loginAdBannerPic || isMobile()) {
      return null;
    }

    return (
      <div className="QR-login-wrapper">
        <img width="255" src={APP_CONFIG.loginAdBannerPic} alt="banner" />
        {APP_CONFIG.loginAdBannerPic.includes("banner2-5.png") && (
          <div
            onClick={() => {
              browserHistory.push("/register/campus");
            }}
            className="banner2-5-hot-link"
          />
        )}
      </div>
    );
  };

  /**
   * 第三方授权登录
   */
  renderOAuthLogin = () => {
    if (this.state.isShowSelectAccount) {
      return null;
    }
    return (
      <OAuthBtn
        type="Login"
        bindChange={() => {
          this.LoginByOAuth = 'Google';
          this.loginPwGtVerify && this.loginPwGtVerify();
          dasService.report("LOGIN_GOOGLE_CLICK");
        }}
      />
    );
  };

  /**
   * 第三方授权登录
   */
  renderOAuthGithubLogin = () => {
    if (this.state.isShowSelectAccount) {
      return null;
    }
    return (
      <OAuthGithub
        type="Login"
        bindChange={() => {
          this.LoginByOAuth = 'GitHub';
          this.loginPwGtVerify && this.loginPwGtVerify();
          dasService.report("LOGIN_GITHUB_CLICK");
        }}
      />
    );
  };

  // 授权第三方登录，生成 OAuth URL
  confirmOAuthBind = (providerType, GtConfig) => {
    const params = {
      Provider: providerType,
      Type: "Login",
      ...GtConfig,
    };
    const self = this;
    request(action.oauth.CreateOAuthURL, params)
      .success(function (data) {
        localStorageService.setItem("PASSPORT_service", self.service);
        window.location.href = data["OAuth"]["AuthURL"];
      })
      .fail(function (error) {
        this.setState({ errorMsg: error['I18N-Message'] || error.Message });
      });
  };

  renderSuperBrowLoginModal = () => {
    const { showLoginSuper, agreeSuperBrow } = this.state;
    return (
      <Modal
        size="sm"
        visible={showLoginSuper}
        maskClosable={false}
        keyboard={false}
        destroyOnClose={true}
        onClose={this.changeshowLoginSuper.bind(this)}
        title={
          <span className="u-color-title u-font-md u-font-wt-bold">
            {localeService.getTranslate("LOGIN74")}
          </span>
        }
        footer={
          <Button
            size="lg"
            styleType="primary"
            disabled={!agreeSuperBrow}
            onClick={this.isAgreeSuperBrow.bind(this)}
          >
            {localeService.getTranslate("LOGIN734")}
          </Button>
        }
      >
        <div className="u-p16 u-line-height u-color-title">
          <p>{localeService.getTranslate("LOGIN70")}</p>
          <p>{localeService.getTranslate("LOGIN71")}</p>
          <p>{localeService.getTranslate("LOGIN72")}</p>
          <Checkbox
            onChange={this.changeAgree.bind(this)}
            checked={agreeSuperBrow}
          />
          <span className="u-color-default">
            {localeService.getTranslate("LOGIN73")}
          </span>
        </div>
      </Modal>
    );
  };

  render() {
    setTitle("LOGIN54");
    return (
      <Box>
        <div className="register-form-wrapper register-flex">
          {this.state.isShowSelectAccount ? (
            this.renderSelectPhoneUserLogin()
          ) : (
            <React.Fragment>
              {/* 邮箱/手机号登录 */}
              {this.renderEmailAndPhoneLogin()}
              {/* 扫码登录 */}
              {this.renderScanCodeLogin()}
              {/* Banner广告位 */}
              {this.renderAdBanner()}
            </React.Fragment>
          )}
        </div>
        {/* 第三方授权登录 */}
        {APP_CONFIG.isOAuthByGoogle && this.renderOAuthLogin()}
        {APP_CONFIG.isOAuthByGithub && this.renderOAuthGithubLogin()}
        {this.renderSuperBrowLoginModal()}
      </Box>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// src/pc/components/LoginForm.jsx